<template>
  <div class="header">
    <div class="head-content">
      <div class="head-left">
        <div class="logo" @click="logoLink()">
          <el-image class="logo_img" :src="logo">
            <span slot="error" class="image-slot">
              <img class="logo_default" :src="logoImg" alt="文化建设云平台" />
            </span>
          </el-image>
        </div>
      </div>
      <div class="head-main">
        <div class="menu" :class="{ 'menu-open': menuVisible }">
          <div class="item" v-for="(item, index) in nemuList" :key="index" :class="{ active: activebtid === index }"
            @click="menubtclick(index, item.component, $event)">
            <span class="span">{{ item.name }}</span>
          </div>
        </div>
        <div class="hamburger" @click="toggleMenu">
          <span :class="{ open: menuVisible }"></span>
          <span :class="{ open: menuVisible }"></span>
          <span :class="{ open: menuVisible }"></span>
        </div>
      </div>
      <div class="head-right">
        <div class="list">
          <div class="item" v-if="!isMobile && bodyWidth > 620">
            <el-input class="global-search" v-model="keyword" placeholder="请输入内容">
              <template slot="append">
                <div class="global-search_btn" @click="headGlobalSearch()">
                  <i class="global-search_icon"></i> 搜索
                </div>
              </template>
            </el-input>
          </div>
          <div class="item" v-if="!isMobile && bodyWidth > 620">
            <el-button type="primary" round :size="isMobile || bodyWidth <= 620 ? 'mini' : ''"
              @click="enterBackend()">文化活动管理</el-button>
          </div>
          <div class="item search-icon-item" v-if="isMobile || bodyWidth <= 620"
            @click="searchVisible = !searchVisible">
            <i class="el-icon-search"></i>
          </div>
          <div class="item" v-if="!token">
            <el-button type="text" @click="login()">登录</el-button>
            <el-button type="text" @click="register()">注册</el-button>
          </div>
          <div class="item" v-if="token">
            <el-dropdown trigger="click">
              <span class="dropdown-link">
                <el-image class="avater" :src="useravater" fit="cover">
                  <span slot="error" class="image-slot">
                    <i class="el-icon-s-custom"></i>
                  </span>
                </el-image>
                <span class="name">{{ getUserName }}</span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="toPersonalCenter()">个人中心</el-dropdown-item>
                <el-dropdown-item @click.native="loginOut()">安全退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <transition name="search-slide">
      <el-input class="global-search mobile-search" v-if="(isMobile || bodyWidth <= 620) && searchVisible"
        v-model="keyword" size="mini" placeholder="请输入内容" @keyup.enter.native="headGlobalSearch()">
        <i slot="suffix" class="el-icon-search mobile-search-btn" @click="headGlobalSearch()"></i>
      </el-input>
    </transition>
  </div>
</template>

<script>
import { getToken, setWebAvaterToken, setWebNameToken } from "@/utils/auth"
import { mapState } from "vuex"
const request_base_path = require("@/utils/base_url")
export default {
  name: "Head",
  components: {},
  data() {
    return {
      isMobile: false, // 判断手机端字段
      bodyWidth: null, // 页面内容宽度
      menuVisible: false, // 移动端菜单显隐
      searchVisible: false, // 移动端搜索显隐
      logoImg: require("@/assets/logo.png"),
      loginText: "文化项目管理平台",
      avater1: require("@/assets/icon/user_student.png"),
      avater2: require("@/assets/icon/user_teacher.png"),
      avater3: require("@/assets/icon/user_administrator.png"),
      avater4: require("@/assets/icon/user_visitor.png"),
      note: require("@/assets/home/note.png"),
      token: getToken() ? true : false,
      islog: false,
      logo: "",
      svgIcon: require("@/assets/icon/menu.png"),
      activeName: "first",
      nemuList: [
        { name: "首页", component: "index" },
        { name: "文化活动", component: "activity" },
        { name: "活动资讯", component: "news" },
        { name: "活动图片", component: "album" },
        { name: "活动直播", component: "live" },
      ],
      // usernumber: "",
      show: false,
      keyword: "",
      noteNum: 0, // 消息数
    }
  },
  computed: {
    ...mapState(["websiteInfo"]),
    activebtid() {
      return this.$store.state.menuactiveid
    },
    // 用户头像
    useravater() {
      let avater = "" // 创建变量接收头像，给与默认值
      const state = this.$store.state || {} // 获取状态保存数据
      if (state.useravater) {
        avater = state.useravater
      }
      this.$store.commit("SET_Useravater", avater) // 记录用户头像
      setWebAvaterToken(avater) // 设置用户头像
      return avater
    },
    getUserName() {
      let username = ""
      const state = this.$store.state || {} // 获取状态保存数据
      if (state.username) {
        username = state.username
        this.$store.commit("SET_Username", username) // 记录用户名
        setWebNameToken(username) // 设置用户名
      } else {
        username = localStorage.getItem("usernumber")
      }
      return username
    },
  },
  watch: {
    websiteInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.logoImg = newVal.portal_head_logo
          this.loginText = newVal.portal_name
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getBrowserMobile() // 判断浏览环境是手机端和pc端
    this.bodyWidth = document.body.clientWidth // 获取body内容的宽度
    // this.usernumber = localStorage.getItem("usernumber") // 获取用户编号
  },
  mounted() { },
  methods: {
    // 判断浏览环境是手机端和pc端
    getBrowserMobile() {
      const regBrowser =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      this.isMobile = navigator.userAgent.match(regBrowser) ? true : false // 判断是否是手机浏览
      return this.isMobile
    },
    // Logo跳转
    logoLink() {
      this.menubtclick(0, "index")
      this.$router.push({
        path: "/home/index",
      })
    },
    // 跳转页面
    menubtclick(id, component, event) {
      this.$store.dispatch("setmenuid", id)
      window.localStorage.setItem("menuId", id)
      this.$router.push("/home/" + component) // 跳转页面
      this.show = false
      this.menuVisible = false
    },
    // 移动端菜单切换
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    // 登录
    login() {
      this.$router.push({ path: "/login" })
    },
    // 注册
    register() {
      this.$router.push({ path: "/register" })
    },
    // 进入后台管理页面
    enterBackend() {
      let token = getToken()
      let params = "?token=" + token
      let location = ""
      let path = ""
      let href = ""
      // 判断运行环境
      if (process.env.NODE_ENV == "development") {
        let index = request_base_path.dev_url.lastIndexOf(":")
        // 通过最后一个冒号判断有没端口，重置本地api
        if (index == 5 || index == 5) {
          location = request_base_path.dev_url
          path = token ? "#/sign_on" + params : "admin/#/login" // 相对路径
        } else {
          // location = request_base_path.dev_url.substring(0,index) + ":9527/"; // 变更端口
          let i = window.location.origin.lastIndexOf(":")
          location = window.location.origin.substring(0, i) + ":9527/" // 变更端口
          path = token ? "#/sign_on" + params : "admin/#/login" // 相对路径
        }
        href = location + path // 本地
        // href = location + '/cas-logout';
      } else if (process.env.NODE_ENV == "production") {
        location = request_base_path.pro_url
        path = token ? "admin/#/sign_on" + params : "admin/#/login" // 相对路径
        href = location + path // 线上
        // href = location + '/cas-logout';  //正式服需要的
      }
      // console.log(href, 'href')
      window.open(href, "_blank") // 拼接外部网址
    },
    // 进入个人中心
    toPersonalCenter() {
      sessionStorage.setItem("router-type", false)
      this.menubtclick(8, "mine")

      let mypage = {
        active: 0,
        componentId: "MyActivity",
      }
      sessionStorage.setItem("my-page", JSON.stringify(mypage))
    },
    // 退出登录
    async loginOut() {
      const systemConfig = sessionStorage.getItem("systemConfig") || ""
      if (systemConfig) {
        const systemInfo = JSON.parse(systemConfig)
        localStorage.removeItem("username")
        localStorage.removeItem("usernumber")
        try {
          let res = await this.$store.dispatch("logout")
          if (res.code === 0) {
            this.token = false
            // if (this.isMobile) {
            if (systemInfo.auth_login_out_sso_direct && process.env.NODE_ENV == "production") {
              window.location.href = systemInfo.auth_login_out_sso_direct //正式服需要的
            } else {
              this.$router.push({ path: "/" }) // 测试服需要的
            }
            // } else {
            //   this.$router.push({ path: "/login" }) //测试服需要的
            // }
            //  this.$router.push({ path: "/" });//测试服需要的
            window.localStorage.setItem("live_login_flag", "0") // 直播
          }
        } catch (error) { }
      } else {
        this.$router.push({ path: "/login" })
      }
    },
    // 全局搜索
    headGlobalSearch() {
      this.$router.push({
        path: "/home/search",
        query: { keyword: this.keyword },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.header {
  height: 70px;
  padding: 0 20px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;

  .head-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;

    .head-left {
      .logo {
        cursor: pointer;

        .logo_img {
          width: auto;
          height: 50px;

          .logo_default {
            width: auto;
            height: 100%;
          }
        }
      }
    }

    .head-right {
      .list {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .item {
          // min-width: 120px;
          margin: 0 5px;
        }
      }

      .dropdown-link {
        display: flex;
        justify-content: center;
        align-items: center;

        .avater {
          width: 50px;
          height: 50px;
          border-radius: 50px;
          margin-right: 5px;
        }

        .name {
          color: #333;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
        }
      }
    }

    .head-main {
      flex: 1;

      .menu {
        width: 60%;
        max-width: 1000px;
        margin: 0 auto;
        display: flex;

        .item {
          width: 20%;
          text-align: center;
          user-select: none;
          white-space: nowrap;
          cursor: pointer;

          .span {
            display: inline-block;
            color: #333;
            font-size: 18px;
            font-weight: 400;
            height: 67px;
            line-height: 70px;
            border-bottom: 3px solid transparent;
          }

          &:hover {
            .span {
              color: #005292;
              border-color: #005292;
            }
          }
        }

        .item.active {
          .span {
            color: #005292;
            font-weight: 700;
            border-color: #005292;
          }
        }
      }

      .hamburger {
        display: none;
        width: 30px;
        height: 24px;
        position: relative;
        cursor: pointer;
        margin-left: auto;

        span {
          display: block;
          width: 100%;
          height: 3px;
          background: #333;
          border-radius: 2px;
          position: absolute;
          left: 0;
          transition: all 0.3s ease;

          &:nth-child(1) {
            top: 0;
          }

          &:nth-child(2) {
            top: 50%;
            transform: translateY(-50%);
          }

          &:nth-child(3) {
            bottom: 0;
          }

          &.open {
            &:nth-child(1) {
              top: 50%;
              transform: translateY(-50%) rotate(45deg);
            }

            &:nth-child(2) {
              opacity: 0;
            }

            &:nth-child(3) {
              bottom: 50%;
              transform: translateY(50%) rotate(-45deg);
            }
          }
        }
      }
    }
  }
}

// 无图占位显示
.image-slot {
  color: #aaa;
  font-size: 30px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

// 全局搜索
.global-search {
  ::v-deep .el-input__inner {
    border: 1px solid #005cbb;
    border-right: none;
    border-radius: 30px 0 0 30px;
  }

  ::v-deep .el-input-group__append {
    padding: 0 !important;
    border: 1px solid #005cbb;
    border-left: none;
    border-radius: 0 30px 30px 0;
  }

  .global-search_btn {
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    min-width: 80px;
    line-height: 38px;
    text-align: center;
    background: #005cbb;
    border-radius: 30px;
    cursor: pointer;

    &:active {
      background: #005cbba9;
    }
  }

  .global-search_icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-image: url('~@/assets/home/search.png');
    background-size: cover;
    vertical-align: middle;
  }
}

@media screen and (max-width: 640px) {
  .header {
    height: 70px;
    overflow: visible;
    padding: 0 10px;

    .head-content {
      height: 70px;
      align-items: center;

      .head-left {
        .logo {
          .logo_img {
            width: auto;
            height: 40px;

            .logo_default {
              width: auto;
              height: 100%;
            }
          }
        }
      }

      .head-main {
        flex: 0 0 auto;
        width: auto;
        display: flex;
        align-items: center;
        margin-left: auto;

        .menu {
          display: none;
          width: 100%;
          flex-direction: column;
          position: absolute;
          top: 70px;
          left: 0;
          right: 0;
          background: #fff;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          z-index: 998;

          .item {
            width: 100%;
            text-align: center;
            border-bottom: 1px solid #eee;

            .span {
              font-size: 16px;
              height: 50px;
              line-height: 50px;
              border-bottom: none;
            }
          }

          &.menu-open {
            display: flex;
          }
        }

        .hamburger {
          display: block;
          width: 25px;
          height: 23px;
        }
      }

      .head-right {
        width: 100%;

        .list {
          display: flex;
          justify-content: space-evenly;
          align-items: center;

          .item {
            // min-width: 50px;
            margin: 0 5px;
            text-align: center;

            .el-button--text {
              font-size: 14px;
              // padding: 5px 10px;
            }

            &.search-icon-item {
              min-width: auto;
              cursor: pointer;

              .el-icon-search {
                font-size: 22px;
                color: #333;
                vertical-align: middle;

                &:active {
                  color: #005cbb;
                }
              }
            }
          }
        }

        .dropdown-link {
          .avater {
            width: 36px;
            height: 36px;
            border-radius: 36px;
            margin-right: 3px;
          }

          .name {
            font-size: 14px;
          }
        }
      }
    }

    .global-search {
      .global-search_btn {
        line-height: 26px;
      }
    }

    .mobile-search {
      position: absolute;
      top: 70px;
      left: 0;
      right: 0;
      height: 56px;
      padding: 0 15px;
      background: #fff;
      box-sizing: border-box;
      z-index: 1000;
      display: flex;
      align-items: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      ::v-deep .el-input__inner {
        height: 36px;
        line-height: 36px;
        border: 1px solid #005cbb;
        border-radius: 30px;
        padding-right: 35px;
      }

      .mobile-search-btn {
        font-size: 18px;
        color: #005cbb;
        cursor: pointer;
        line-height: 36px;
        padding: 0 8px;

        &:active {
          color: #003d80;
        }
      }

      ::v-deep .el-input__suffix {
        height: 100%;
        right: 20px;
        transition: all 0.3s;
        pointer-events: none;
        top: 10px;

      }
    }
  }

  .search-slide-enter-active {
    transition: all 0.3s ease;
  }

  .search-slide-leave-active {
    transition: all 0.3s ease;
  }

  .search-slide-enter,
  .search-slide-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }

  .search-slide-enter-to,
  .search-slide-leave {
    max-height: 50px;
    opacity: 1;
  }
}

@media screen and (min-width: 620px) and (max-width: 1200px) {
  .header {
    .head-content {
      .head-left {
        .logo {
          .logo_img {
            width: auto;
            height: 40px;

            .logo_default {
              width: auto;
              height: 100%;
            }
          }
        }
      }

      .head-main {
        .menu {
          width: calc(100% - 40px);
          min-width: 350px;

          .item {
            .span {
              font-size: 16px;
            }
          }
        }
      }

      .head-right {
        .list {
          .item {
            // min-width: 100px;
            min-width: auto;
            margin: 0 2px;
          }
        }

        .dropdown-link {
          .name {
            font-size: 14px;
          }

          .avater {
            width: 30px;
            height: 30px;
          }
        }

        // 全局搜索
        .global-search {
          ::v-deep .el-input__inner {
            height: 30px;
            line-height: 30px;
          }

          .global-search_btn {
            min-width: 60px;
            line-height: 28px;
          }
        }

        .el-button {
          padding: 7px 10px !important;
          margin: 0;
          font-size: 12px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .header {
    .head-content {
      .head-left {
        .logo {
          .logo_img {
            width: auto;
            height: 50px;

            .logo_default {
              width: auto;
              height: 100%;
            }
          }
        }
      }

      .head-main {
        .menu {
          width: 60%;
          min-width: 420px;

          .item {
            .span {
              font-size: 18px;
            }
          }
        }
      }

      .head-right {

        // 全局搜索
        .global-search {
          .global-search_btn {
            min-width: 80px;
            line-height: 38px;
          }
        }
      }
    }
  }
}
</style>